/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Typst_UnlockInputs */

const cs_builder_typst_unlock = /** @type {(inputs: Builder_Typst_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odemknout Typst`)
};

const en_builder_typst_unlock = /** @type {(inputs: Builder_Typst_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock Typst`)
};

/**
* | output |
* | --- |
* | "Unlock Typst" |
*
* @param {Builder_Typst_UnlockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_typst_unlock = /** @type {((inputs?: Builder_Typst_UnlockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Typst_UnlockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_typst_unlock(inputs)
	return cs_builder_typst_unlock(inputs)
});